/**
 * This file is used to inject the gtag function into the app.
 * The gtag function is used to send events to Google Analytics 4 through
 * Google Tag Manager.
 *
 * Note: This file doesn't track pageviews. Pageviews events are sent on `ga-spa.js`
 */

const gtag = function gtag() {
  window.dataLayer = window.dataLayer || [];

  // Using the spread operator won't work, so `parameter` is required.
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
};

const getGA4UserType = function getGA4UserType(user) {
  let userType = 'customer';

  if (user.is_staff) {
    userType = 'staff';
  } else if (user.is_betaling) {
    userType = 'betaling';
  } else if (user.has_plus) {
    userType = 'plus';
  }

  return userType;
};

export default function ({ store }, inject) {
  const { user } = store.state.session;

  gtag('js', new Date());

  if (user) {
    const userData = {
      userId: user.id,
      userEmail: user.email,
      userEmailHash: user.email_hash,
      hasPlus: user.has_plus,
      hasBriefcase: user.hasBriefcase,
      isStaff: user.is_staff,
      isBetaling: user.is_betaling,
    };

    // Custom parameters to be sent on every event. These are added on the root
    // of the dataLayer, they are not added to the `eventModel` parameter.
    gtag('set', userData);

    // Custom event to know when the user data was set and trigger tags that depends
    // on user data. i.e: The klaviyo identify tag.
    gtag('event', 'set_user_data');

    gtag('set', 'user_properties', {
      user_type: getGA4UserType(user),
    });
  }

  inject('gtag', gtag);
}
